/**
 * Created by dmitry on 24.08.2026
 */

WindowPersons.prototype.createPerson = cleverapps.extendFunc(WindowPersons.prototype.createPerson, function (options) {
    const parsed = Person.ParseOptions(options);

    if (!parsed.json && !cleverapps.persons.getRole(parsed.role)) {
        return undefined;
    }

    return this._super(options);
});
